export default "__VITE_PUBLIC_ASSET__c1821c31__"